export function locationOf(element, array, start, end) {
  start = start || 0;
  end = end || array.length;
  var pivot = parseInt(start + (end - start) / 2, 10);
  if (array[pivot].fValue === element) return pivot;
  if (end - start <= 1) return array[pivot].fValue > element ? pivot - 1 : pivot;
  if (array[pivot].fValue < element) {
    return locationOf(element, array, pivot, end);
  } else {
    //  gOverflowCounter++;
    //  if (gOverflowCounter > 50)
    //      console.log("Stack Overflow!");

    return locationOf(element, array, start, pivot);
  }
}
